import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'deliveryEstimateInProgress',
  initialState: false,
  reducers: {
    setDeliveryEstimateInProgress(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setDeliveryEstimateInProgress } = slice.actions;

export default slice.reducer;
